// import useState from 'react-usestateref';
// import { useStorage } from './hooks/use-storage';
// import { useXXXModal } from './new-modal';

import { useRef } from 'react';
import _ from 'lodash';
import { useStorage } from '../hooks/use-storage';
import { useAuthWorkflow } from './auth-workflow';
import { usePaymentWorkflow } from './payment-workflow';
// import { useAddressWorkflow } from './address-workflow';
import { useAddressWorkflow } from './address-workflow';
import { useLostChangesModal } from '../screens/order/lost-changes-modal';
import { useMobileWorkflow } from './mobile-workflow';
import { useSessionDetailWorkflow } from './session-detail-workflow';
import { useSessionApi } from '../apis/session-api';

function useCheckoutWorkflow() {
  const { userRef, spot } = useStorage();
  const { preparePaymentWorkflow, showPaymentWorkflow } = usePaymentWorkflow();
  const { prepareAuthWorkflow, showAuthWorkflow } = useAuthWorkflow();
  const { prepareAddressWorkflow, showAddressWorkflow } = useAddressWorkflow();
  const { showLostChangesModal } = useLostChangesModal();
  const { prepareMobileWorkflow, showMobileWorkflow } = useMobileWorkflow();
  const { prepareSessionDetailWorkflow, showSessionDetailWorkflow } =
    useSessionDetailWorkflow();

  const { setSessionDeliveryAddressFromRemote } = useSessionApi();

  // const addressable = spot?.type?.addressable ?? false;
  // const prepaid = spot?.prepaid ?? false;

  const selectedOrdersRef = useRef();
  const updateOrdersRef = useRef();

  async function prepare({ selectedOrders, updateOrders }) {
    selectedOrdersRef.current = selectedOrders;
    updateOrdersRef.current = updateOrders;

    if (userRef.current == null) {
      await prepareAuthWorkflow();
    }

    const addressable = spot?.type?.addressable ?? false;

    if (userRef.current != null) {
      if (addressable) {
        await prepareAddressWorkflow();
      }

      if (!addressable && userRef.current != null) {
        await preparePaymentWorkflow({
          selectedOrders,
          updateOrders,
        });
      }
    }
  }

  async function show(
    { autoLoaded, prepareOnPreConfirm, prepareOnPreDeny } = {
      autoLoaded: false,
    }
  ) {
    let result = {};
    const addressable = spot?.type?.addressable ?? false;

    if (userRef.current == null) {
      const showResult = await showAuthWorkflow({
        prepareOnPreConfirm: async () => {
          if (addressable) {
            await prepareAddressWorkflow();
          }

          if (!addressable) {
            await preparePaymentWorkflow({
              selectedOrders: selectedOrdersRef.current,
              updateOrders: updateOrdersRef.current,
            });
          }

          await prepareOnPreConfirm?.call(this);
        },
        prepareOnPreDeny,
      });

      result = _.merge(result, showResult);
    }

    let repeat;

    do {
      if (userRef.current != null) {
        if (
          addressable &&
          !result.wasSessionDetailWorkflowBackButtonPressed &&
          !result.wasPaymentWorkflowBackButtonPressed
        ) {
          // eslint-disable-next-line no-await-in-loop
          const showResult = await showAddressWorkflow({
            prepareOnPreConfirm: async () => {
              await prepareMobileWorkflow();
              await prepareOnPreConfirm?.call(this);
            },
            prepareOnPreDeny,
          });

          result.isConfirmed = false;
          result.isDismissed = false;
          result.isDenied = false;
          result.wasMobileWorkflowBackButtonPressed = false;

          result = _.merge(result, showResult);
        }

        if (
          (result.isConfirmed &&
            addressable &&
            !result.wasPaymentWorkflowBackButtonPressed) ||
          result.wasSessionDetailWorkflowBackButtonPressed
        ) {
          // eslint-disable-next-line no-await-in-loop
          const showResult = await showMobileWorkflow({
            showBackButton: true,
            // eslint-disable-next-line no-loop-func
            prepareOnPreConfirm: async () => {
              const orders = await updateOrdersRef.current();
              const session = _.head(orders)?.session;

              await setSessionDeliveryAddressFromRemote(session.id, {
                user_address: {
                  id: result.address.id,
                },
              });

              await prepareSessionDetailWorkflow({
                address: result.address,
                updateOrders: updateOrdersRef.current,
              });
            },
            prepareOnPreDeny: prepareAddressWorkflow,
          });

          result.isConfirmed = false;
          result.isDismissed = false;
          result.isDenied = false;
          result.wasSessionDetailWorkflowBackButtonPressed = false;

          result = _.merge(result, showResult);

          result.wasMobileWorkflowBackButtonPressed = result.isDenied;
        }

        if (
          (result.isConfirmed && addressable) ||
          result.wasPaymentWorkflowBackButtonPressed
        ) {
          // eslint-disable-next-line no-await-in-loop
          const showResult = await showSessionDetailWorkflow({
            prepareOnPreConfirm: async () => {
              await preparePaymentWorkflow({
                selectedOrders: selectedOrdersRef.current,
                updateOrders: updateOrdersRef.current,
              });

              await prepareOnPreConfirm?.call(this);
            },
            prepareOnPreDeny: prepareMobileWorkflow,
          });

          result.wasPaymentWorkflowBackButtonPressed = false;

          result.isConfirmed = false;
          result.isDismissed = false;
          result.isDenied = false;

          result = _.merge(result, showResult);
        }

        if (result.isConfirmed || !addressable) {
          // eslint-disable-next-line no-await-in-loop
          const showResult = await showPaymentWorkflow({
            showBackButton: addressable,
            autoLoaded,
            prepareOnPreConfirm,
            prepareOnPreDeny,
          });

          result.isConfirmed = false;
          result.isDismissed = false;
          result.isDenied = false;

          result = _.merge(result, showResult);

          result.wasPaymentWorkflowBackButtonPressed =
            result.isDismissed && addressable;
        }
      }

      const prepaid = spot?.prepaid ?? false;

      if (
        !result.isConfirmed &&
        prepaid &&
        !result.wasMobileWorkflowBackButtonPressed &&
        !result.wasPaymentWorkflowBackButtonPressed
      ) {
        // eslint-disable-next-line no-await-in-loop
        await showLostChangesModal({ forceLostMessage: true });
      }

      repeat =
        result.wasMobileWorkflowBackButtonPressed ||
        result.wasPaymentWorkflowBackButtonPressed;
    } while (repeat);

    // if (true) {
    //   showMobileModal();
    // }

    return result;
  }

  return {
    prepareCheckoutWorkflow: prepare,
    showCheckoutWorkflow: show,
  };
}

export { useCheckoutWorkflow };
